import { render } from "./StatsWidgetTitleConfig.vue?vue&type=template&id=fa45fee0"
import script from "./StatsWidgetTitleConfig.vue?vue&type=script&lang=ts"
export * from "./StatsWidgetTitleConfig.vue?vue&type=script&lang=ts"

import "./StatsWidgetTitleConfig.vue?vue&type=style&index=0&id=fa45fee0&lang=scss"
script.render = render

export default script